import React from 'react';
import { connect } from 'react-redux';
import './Fax.css';

const FailureSummary = ({ fax }) => {
  const { date, totalFailed, reason } = fax;
  return (
    <tr>
      <td>{date}</td>
      <td>{totalFailed}</td>
      <td>{reason}</td>
    </tr>
  );
};

const mapStateToProps = state => ({
  user: state.AppState.user,
});

export default connect(mapStateToProps)(FailureSummary);
